import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FileItem from '../FileItem';

const FileList = ({
  files,
  handleDeleteFile,
  handleFileSelected,
  selectedFileIndex,
  fileSelection,
  showUploadButton
}) =>
  files.length > 0 ? (
    <div className={classnames({ 'mt-1x': showUploadButton })}>
      {files.map((file, index) => (
        <FileItem
          key={index}
          file={file}
          onDelete={handleDeleteFile(file)}
          fileSelection={fileSelection}
          checked={selectedFileIndex === index}
          onCheck={handleFileSelected(index)}
          showUploadButton={showUploadButton}
        />
      ))}
    </div>
  ) : null;

FileList.defaultProps = {
  files: []
};

FileList.propTypes = {
  files: PropTypes.array,
  handleDeleteFile: PropTypes.func.isRequired,
  handleFileSelected: PropTypes.func.isRequired,
  showUploadButton: PropTypes.bool,
  selectedFileIndex: PropTypes.number,
  fileSelection: PropTypes.bool.isRequired
};

export default FileList;
